import Image from 'next/image'
import { CSSProperties } from 'react'
import { useSelector } from 'react-redux'
import PropertyStatus from '#/components/PropertyStatus'
import { currentRoleWithShared } from '#/store/selectors/user'
import usePrice from '../../hooks/usePrice'
import Facts from '../Facts'

type Props = {
  className?: string
  property: TopHap.ExtendedProperty
  style?: CSSProperties
}

const OverviewInfo: React.FC<Props> = ({ className, property, style }) => {
  const userRole = useSelector(currentRoleWithShared)
  const hasRole = userRole && userRole !== 'free'
  const formatted = usePrice(property, hasRole)

  return (
    <div className={className} style={style}>
      <div className='flex h-[52px] items-end space-x-2 overflow-hidden bg-white px-4 py-1 hover:overflow-auto'>
        {property.media?.photos[0] && (
          <div className='h-full flex-none'>
            <Image
              alt={property.displayAddress}
              className='h-full rounded-lg object-cover'
              height={44}
              src={property.media?.photos[0]}
              width={64}
            />
          </div>
        )}
        <div>
          <PropertyStatus property={property} showDate={false} />
          <div className='flex justify-center px-0.5 text-right'>
            <div className='text-sm font-bold'>
              {formatted.Price}
            </div>
          </div>
        </div>
        <Facts
          className='w-full overflow-x-visible p-0'
          hideDots
          itemClass='shadow-none px-1 h-10 w-auto'
          property={property}
          valueClass='text-sm'
        />
      </div>
    </div>
  )
}

export default OverviewInfo
